import PropTypes from "prop-types";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

// Stopping a capture ends the tapestry, whichever source is being heard, so
// every capture bar asks once, in the same words.
const StopCaptureDialog = ({ open, onClose, onStop, resumable = false }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Stop capturing?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        This ends the live tapestry. The transcript and tapestry so far are kept; capture cannot be resumed into the
        same tapestry.
        {resumable && " To take a break instead, pause it."}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Keep going</Button>
      <Button color="error" onClick={onStop}>
        Stop
      </Button>
    </DialogActions>
  </Dialog>
);

StopCaptureDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onStop: PropTypes.func.isRequired,
  /** The source can be paused, so the dialog points the hesitant there. */
  resumable: PropTypes.bool,
};

export default StopCaptureDialog;
